<template>
  <div class="rowflex" align="center">
    <ul style="list-style: none; margin-bottom: 0" align="center">
      <li>
        <h2 style="font-weight: 500">{{ header }}</h2>
      </li>
      <li
        class="mt-4"
        align="center"
        style="
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        "
      >
        <h1 style="font-weight: 500; font-size: 3rem; color: #80828b">250</h1>
        <ul class="ml-2" style="list-style: none; margin-bottom: 0">
          <li><vs-icon icon="south" size="15px" color="red"></vs-icon></li>
          <li class="text-danger">20</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["header", "detail"],
};
</script>

<style scoped>
.rowflex {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>